export default {
  filters: {
    updated: 'filters:updated',
  },
  sort: {
    updated: 'sort:updated',
  },
  reviews: {
    added: 'reviews:added',
  },
  headerOverlay: {
    show: 'headerOverlay:show',
    hide: 'headerOverlay:hide',
    hiding: 'headerOverlay:hiding',
  },
  drawerOverlay: {
    show: 'drawerOverlay:show',
    hide: 'drawerOverlay:hide',
    hiding: 'drawerOverlay:hiding',
  },
};
